import React from 'react'
import style from './LoadingBar.module.sass'

export const LoadingBar: React.FunctionComponent = () => {
	return <div className={style.wrapper} />
}
